var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var SearchForm = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: 6;\n"], ["\n  flex: 6;\n"])));
export default SearchForm;
var templateObject_1;
